import { insertInArray } from './array';
import { toAbsoluteLink, toCategoryLink, toSubcategoryLink } from './links';
import { toFormattedJsonLdString } from './string';

import APP from 'constants/app';
import OFFER from 'constants/offer';

export const appendDynamicSubcategoryToBreadcrumbSchema = (
  breadcrumbSchema,
  subcategoryName,
  subcategorySlug
) => {
  if (!subcategoryName) {
    return breadcrumbSchema;
  }

  const breadcrumbSchemaArr = insertInArray({
    array: breadcrumbSchema,
    position: 2,
    item: {
      position: 3,
      name: subcategoryName,
      item: toSubcategoryLink(subcategorySlug),
    },
  });

  breadcrumbSchemaArr[3].position = 4;

  return breadcrumbSchemaArr;
};

export const getCategoryBreadcrumbArr = ({
  categoryName,
  categorySlug,
  subcategoryName = null,
  subcategorySlug,
  deepSubcategoryName = null,
  deepSubcategorySlug,
}) => {
  const baseBreadcrumbArr = [
    {
      position: 1,
      name: 'Promoções',
      item: APP.URL,
    },
    {
      position: 2,
      name: categoryName,
      item: toAbsoluteLink(toCategoryLink(categorySlug)),
    },
  ];

  if (subcategoryName) {
    baseBreadcrumbArr.push({
      position: 3,
      name: subcategoryName,
      item: toAbsoluteLink(toSubcategoryLink(subcategorySlug)),
    });
  }

  if (deepSubcategoryName) {
    baseBreadcrumbArr.push({
      position: 4,
      name: deepSubcategoryName,
      item: toAbsoluteLink(toSubcategoryLink(deepSubcategorySlug)),
    });
  }

  return baseBreadcrumbArr;
};

export const toReviewSchema = (reviews, offerTitle = '') =>
  reviews.map(({ raw, date, user, stars }) => ({
    datePublished: date,
    name: offerTitle && `Review de ${toFormattedJsonLdString(offerTitle)}`,
    reviewBody: toFormattedJsonLdString(raw.replace(/\n/g, '')),
    author: {
      type: 'Person',
      name: user.username,
    },
    publisher: {
      type: 'Organization',
      name: APP.NAME,
    },
    reviewRating: {
      bestRating: '5',
      ratingValue: stars || OFFER.REVIEWS.DEFAULT_RATING_VALUE,
      worstRating: '1',
    },
  }));
